import React from 'react'

import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { ValueMember } from 'modules/finance/pages/DimensionValueDetailPage/DimensionValueDetail/DimensionValueMembers/types'

interface CellTextProps {
  ellipsis?: boolean
  weight?: 'normal' | 'medium'
  children: React.ReactNode
}
const CellText = ({ ellipsis = true, weight = 'normal', children }: CellTextProps) => (
  <Text.Normal weight={weight} color="grey1000" whiteSpace="nowrap" ellipsis={ellipsis}>
    {children}
  </Text.Normal>
)
interface Props {
  members: ValueMember[]
  isMultipleValue?: boolean
}
const List = ({ members, isMultipleValue = false }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Table.Body>
      {members.map((member) => (
        <Table.Row key={member.id}>
          <Table.Cell colSpan={2}>
            <CellText weight="medium">{member.employee.firstName}</CellText>
          </Table.Cell>
          <Table.Cell colSpan={3}>
            <CellText weight="medium">{member.employee.lastName}</CellText>
          </Table.Cell>
          <Table.Cell colSpan={3}>
            <CellText>
              {member.employee.referenceContract?.jobCatalogLevel?.role?.name ||
                member.employee.referenceContract?.jobTitle}
            </CellText>
          </Table.Cell>
          {isMultipleValue && <Table.Cell colSpan={3}>-</Table.Cell>}
          <Table.Cell colSpan={1}>
            <Box alignItems="flexEnd" justifyContent="flexEnd">
              <Button.Router
                type="secondary"
                to={navigation.employees.id.workDetails.fullPath({ id: member.employee.id })}
                iconName="arrow-right"
              />
            </Box>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  )
}

export default List
